import { c as _c } from "react/compiler-runtime";
import { useAuth0, User } from "@auth0/auth0-react";
import { getAccessToken } from "../../../../hooks/useApi";
import { useState } from "react";
import { TaxUnit } from "../../../../models";
import { Lightbox } from "../../../shared/components/Lightbox/Lightbox";
import { RadioButtonGroup } from "../../../shared/components/RadioButton/RadioButtonGroup";
import { createTaxUnit } from "../../_queries";
import { toast } from "react-toastify";
import styles from "./TaxUnitModal.module.scss";
import { AlertCircle, Check } from "react-feather";
import { Spinner } from "../../../shared/components/Spinner/Spinner";
import { useTaxUnits } from "../../../../_queries";
import { EffektTextInput } from "../../../shared/components/EffektTextInput/EffektTextInput";
import { validateTin, formatTinInput } from "../../../../util/tin-validation";
import { TaxUnitTypes } from "./taxUnitTypes";
export const DKTaxUnitCreateModal: React.FC<{
  open: boolean;
  onSuccess: (unit: TaxUnit) => void;
  onFailure: () => void;
  onClose: () => void;
}> = t0 => {
  const $ = _c(81);
  const {
    open,
    onSuccess,
    onFailure,
    onClose
  } = t0;
  const {
    getAccessTokenSilently,
    user
  } = useAuth0();
  const {
    data: existingUnits,
    loading: loadingUnits
  } = useTaxUnits(user as User, getAccessTokenSilently);
  const [name, setName] = useState("");
  const [ssn, setSsn] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [type, setType] = useState(TaxUnitTypes.PERSON);
  let t1;
  if ($[0] !== getAccessTokenSilently || $[1] !== name || $[2] !== onFailure || $[3] !== onSuccess || $[4] !== ssn || $[5] !== user) {
    t1 = async () => {
      setLoading(true);
      const token = await getAccessToken(getAccessTokenSilently);
      if (!user) {
        return;
      }
      const ssnDigits = ssn.replace(/\D/g, "");
      const result = await createTaxUnit({
        name,
        ssn: ssnDigits
      }, user, token);
      if (result && typeof result !== "string") {
        successToast();
        onSuccess(result);
        setError("");
      } else {
        if (typeof result === "string") {
          setLoading(false);
          onFailure();
          failureToast();
          setError(result);
        } else {
          setLoading(false);
          onFailure();
          failureToast();
          setError("");
        }
      }
    };
    $[0] = getAccessTokenSilently;
    $[1] = name;
    $[2] = onFailure;
    $[3] = onSuccess;
    $[4] = ssn;
    $[5] = user;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const create = t1;
  if (loadingUnits) {
    let t2;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <Spinner />;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    return t2;
  }
  let t2;
  if ($[8] !== ssn) {
    let t3;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = /\D/g;
      $[10] = t3;
    } else {
      t3 = $[10];
    }
    t2 = ssn.replace(t3, "");
    $[8] = ssn;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const ssnDigits_0 = t2;
  let t3;
  if ($[11] !== existingUnits || $[12] !== ssnDigits_0) {
    t3 = existingUnits?.some(unit => unit.ssn.replace(/\D/g, "") === ssnDigits_0);
    $[11] = existingUnits;
    $[12] = ssnDigits_0;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  const ssnIsExistingUnit = t3;
  let t4;
  if ($[14] !== ssn || $[15] !== ssnDigits_0.length || $[16] !== type) {
    t4 = type === TaxUnitTypes.PERSON && ssnDigits_0.length === 10 ? validateTin(ssn, {
      allowCvr: false
    }) : null;
    $[14] = ssn;
    $[15] = ssnDigits_0.length;
    $[16] = type;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  const cprValidation = t4;
  const validatePersonId = _temp;
  const validateCompanyId = _temp2;
  let t5;
  if ($[18] !== ssn || $[19] !== ssnDigits_0.length || $[20] !== ssnIsExistingUnit || $[21] !== type) {
    t5 = !ssnIsExistingUnit && ssn !== "" && (type === TaxUnitTypes.PERSON ? ssnDigits_0.length === 10 && validatePersonId(ssn) : ssnDigits_0.length === 8 && validateCompanyId(ssn));
    $[18] = ssn;
    $[19] = ssnDigits_0.length;
    $[20] = ssnIsExistingUnit;
    $[21] = type;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  const isValid = t5;
  let t6;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <h5>Ny skatteenhed</h5>;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = [{
      title: "Person",
      value: TaxUnitTypes.PERSON,
      data_cy: "tax-unit-create-modal-type-person"
    }, {
      title: "Virksomhed",
      value: TaxUnitTypes.COMPANY,
      data_cy: "tax-unit-create-modal-type-company"
    }];
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = type_0 => {
      setType(type_0);
    };
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== type) {
    t9 = <div className={styles.typeSelector}><RadioButtonGroup options={t7} selected={type} onSelect={t8} /></div>;
    $[26] = type;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <label className={styles.label}>Navn</label>;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = val_1 => setName(val_1);
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== name) {
    t12 = <div className={styles.inputContainer}>{t10}<EffektTextInput value={name} onChange={t11} /></div>;
    $[30] = name;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  const t13 = type === TaxUnitTypes.PERSON ? "CPR-nummer" : "CVR-nummer";
  let t14;
  if ($[32] !== t13) {
    t14 = <label className={styles.label}>{t13}</label>;
    $[32] = t13;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== type) {
    t15 = val_2 => setSsn(formatTinInput(val_2, {
      allowCvr: type === TaxUnitTypes.COMPANY
    }));
    $[34] = type;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== ssn || $[37] !== t15) {
    t16 = <EffektTextInput value={ssn} onChange={t15} />;
    $[36] = ssn;
    $[37] = t15;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== cprValidation) {
    t17 = cprValidation && !cprValidation.isValid && <div>Ugyldigt CPR-nummer</div>;
    $[39] = cprValidation;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== cprValidation?.isSuspicious || $[42] !== cprValidation?.isValid) {
    t18 = cprValidation?.isValid && cprValidation?.isSuspicious && <div data-cy="cpr-suspicious-message">Kontroller venligst at det er korrekt.</div>;
    $[41] = cprValidation?.isSuspicious;
    $[42] = cprValidation?.isValid;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  let t19;
  if ($[44] !== ssn || $[45] !== ssnDigits_0.length || $[46] !== type) {
    t19 = ssnDigits_0.length === 8 && type === TaxUnitTypes.COMPANY && !validateCompanyId(ssn) && <div>Ugyldigt CVR-nummer</div>;
    $[44] = ssn;
    $[45] = ssnDigits_0.length;
    $[46] = type;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  let t20;
  if ($[48] !== ssnDigits_0.length || $[49] !== type) {
    t20 = ssnDigits_0.length !== 10 && type === TaxUnitTypes.PERSON && <div>10 cifre</div>;
    $[48] = ssnDigits_0.length;
    $[49] = type;
    $[50] = t20;
  } else {
    t20 = $[50];
  }
  let t21;
  if ($[51] !== ssnDigits_0.length || $[52] !== type) {
    t21 = ssnDigits_0.length !== 8 && type === TaxUnitTypes.COMPANY && <div>8 cifre</div>;
    $[51] = ssnDigits_0.length;
    $[52] = type;
    $[53] = t21;
  } else {
    t21 = $[53];
  }
  let t22;
  if ($[54] !== ssnIsExistingUnit) {
    t22 = ssnIsExistingUnit && <div>Skatteenhed findes allerede</div>;
    $[54] = ssnIsExistingUnit;
    $[55] = t22;
  } else {
    t22 = $[55];
  }
  let t23;
  if ($[56] !== t17 || $[57] !== t18 || $[58] !== t19 || $[59] !== t20 || $[60] !== t21 || $[61] !== t22) {
    t23 = <div className={styles.ssnValidation}>{t17}{t18}{t19}{t20}{t21}{t22}</div>;
    $[56] = t17;
    $[57] = t18;
    $[58] = t19;
    $[59] = t20;
    $[60] = t21;
    $[61] = t22;
    $[62] = t23;
  } else {
    t23 = $[62];
  }
  let t24;
  if ($[63] !== t14 || $[64] !== t16 || $[65] !== t23) {
    t24 = <div className={styles.inputContainer}>{t14}{t16}{t23}</div>;
    $[63] = t14;
    $[64] = t16;
    $[65] = t23;
    $[66] = t24;
  } else {
    t24 = $[66];
  }
  let t25;
  if ($[67] !== error) {
    t25 = error && <div className={styles.error}>{error}</div>;
    $[67] = error;
    $[68] = t25;
  } else {
    t25 = $[68];
  }
  let t26;
  if ($[69] !== t12 || $[70] !== t24 || $[71] !== t25 || $[72] !== t9) {
    t26 = <div className={styles.container}>{t6}{t9}{t12}{t24}{t25}</div>;
    $[69] = t12;
    $[70] = t24;
    $[71] = t25;
    $[72] = t9;
    $[73] = t26;
  } else {
    t26 = $[73];
  }
  let t27;
  if ($[74] !== create || $[75] !== isValid || $[76] !== loading || $[77] !== onClose || $[78] !== open || $[79] !== t26) {
    t27 = <Lightbox open={open} onConfirm={create} onCancel={onClose} valid={isValid} loading={loading}>{t26}</Lightbox>;
    $[74] = create;
    $[75] = isValid;
    $[76] = loading;
    $[77] = onClose;
    $[78] = open;
    $[79] = t26;
    $[80] = t27;
  } else {
    t27 = $[80];
  }
  return t27;
};
const successToast = () => toast.success("Gemt", {
  icon: <Check size={24} color={"black"} />
});
const failureToast = () => toast.error("Noget gik galt", {
  icon: <AlertCircle size={24} color={"black"} />
});
function _temp(val) {
  return validateTin(val, {
    allowCvr: false
  }).isValid;
}
function _temp2(val_0) {
  return validateTin(val_0, {
    allowCvr: true
  }).type === "CVR" && validateTin(val_0, {
    allowCvr: true
  }).isValid;
}